import { BaseSanitizer } from './BaseSanitizer';
import validator from 'validator';
export class MacAddressSanitizer extends BaseSanitizer {
    constructor(context, enabled = true) {
        super(context, 'MAC_ADDRESS', 'macAddresses', enabled);
    }
    detectMatches(text) {
        const matches = [];
        const patterns = [
            /\b([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})\b/g, // 00:1A:2B:3C:4D:5E or 00-1A-2B-3C-4D-5E
            /\b([0-9A-Fa-f]{4}\.){2}([0-9A-Fa-f]{4})\b/g // 001A.2B3C.4D5E (Cisco style)
        ];
        for (const pattern of patterns) {
            let match;
            while ((match = pattern.exec(text)) !== null) {
                const macAddress = match[0];
                if (validator.isMACAddress(macAddress)) {
                    matches.push({
                        originalText: macAddress,
                        tag: '',
                        startIndex: match.index,
                        endIndex: match.index + macAddress.length
                    });
                }
            }
        }
        return this.removeOverlappingMatches(matches);
    }
}
